/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAccountRouteImport } from './routes/_app/account'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as PublicCloseAccountRouteImport } from './routes/_public/close-account'
import { Route as PublicForgotPasswordRouteImport } from './routes/_public/forgot-password'
import { Route as PublicInvitationRouteImport } from './routes/_public/invitation'
import { Route as PublicRegisterRouteImport } from './routes/_public/register'
import { Route as PublicResetPasswordRouteImport } from './routes/_public/reset-password'
import { Route as PublicSignInRouteImport } from './routes/_public/sign-in'
import { Route as PublicTwoFactorRouteImport } from './routes/_public/two-factor'
import { Route as PublicVerifyEmailRouteImport } from './routes/_public/verify-email'
import { Route as AppAccountSecurityRouteImport } from './routes/_app/account.security'
import { Route as AppAdminIndexRouteImport } from './routes/_app/admin.index'
import { Route as AppAdminOrgIdRouteImport } from './routes/_app/admin.$orgId'
import { Route as AppAdminAbuseRouteImport } from './routes/_app/admin.abuse'
import { Route as AppAdminAccessRouteImport } from './routes/_app/admin.access'
import { Route as AppAdminActivityRouteImport } from './routes/_app/admin.activity'
import { Route as AppAdminBuildsRouteImport } from './routes/_app/admin.builds'
import { Route as AppAdminCertificatesRouteImport } from './routes/_app/admin.certificates'
import { Route as AppAdminConsoleRouteImport } from './routes/_app/admin.console'
import { Route as AppAdminDatabasesRouteImport } from './routes/_app/admin.databases'
import { Route as AppAdminFleetRouteImport } from './routes/_app/admin.fleet'
import { Route as AppAdminInvoicesRouteImport } from './routes/_app/admin.invoices'
import { Route as AppAdminJobsRouteImport } from './routes/_app/admin.jobs'
import { Route as AppAdminOrganisationsRouteImport } from './routes/_app/admin.organisations'
import { Route as AppAdminPricesRouteImport } from './routes/_app/admin.prices'
import { Route as AppAdminRevenueRouteImport } from './routes/_app/admin.revenue'
import { Route as AppAdminServicesRouteImport } from './routes/_app/admin.services'
import { Route as AppAdminStaffRouteImport } from './routes/_app/admin.staff'
import { Route as AppAdminTokensRouteImport } from './routes/_app/admin.tokens'
import { Route as AppAdminVolumesRouteImport } from './routes/_app/admin.volumes'
import { Route as AppAdminWebhooksRouteImport } from './routes/_app/admin.webhooks'
import { Route as AppConnectionsGithubRouteImport } from './routes/_app/connections.github'
import { Route as AppOOrgIdRouteImport } from './routes/_app/o.$orgId'
import { Route as AppAdminTicketsIndexRouteImport } from './routes/_app/admin.tickets.index'
import { Route as AppAdminTicketsTicketIdRouteImport } from './routes/_app/admin.tickets.$ticketId'
import { Route as AppAdminUsersIndexRouteImport } from './routes/_app/admin.users.index'
import { Route as AppAdminUsersUserIdRouteImport } from './routes/_app/admin.users.$userId'
import { Route as AppOOrgIdIndexRouteImport } from './routes/_app/o.$orgId.index'
import { Route as AppOOrgIdAuditRouteImport } from './routes/_app/o.$orgId.audit'
import { Route as AppOOrgIdBillingRouteImport } from './routes/_app/o.$orgId.billing'
import { Route as AppOOrgIdConnectionsRouteImport } from './routes/_app/o.$orgId.connections'
import { Route as AppOOrgIdMembersRouteImport } from './routes/_app/o.$orgId.members'
import { Route as AppOOrgIdNotificationsRouteImport } from './routes/_app/o.$orgId.notifications'
import { Route as AppOOrgIdOrderRouteImport } from './routes/_app/o.$orgId.order'
import { Route as AppOOrgIdSettingsRouteImport } from './routes/_app/o.$orgId.settings'
import { Route as AppOOrgIdTokensRouteImport } from './routes/_app/o.$orgId.tokens'
import { Route as AppOOrgIdBillingIndexRouteImport } from './routes/_app/o.$orgId.billing.index'
import { Route as AppOOrgIdBillingCreditRouteImport } from './routes/_app/o.$orgId.billing.credit'
import { Route as AppOOrgIdBillingInvoicesRouteImport } from './routes/_app/o.$orgId.billing.invoices'
import { Route as AppOOrgIdProjectsIndexRouteImport } from './routes/_app/o.$orgId.projects.index'
import { Route as AppOOrgIdSupportIndexRouteImport } from './routes/_app/o.$orgId.support.index'
import { Route as AppOOrgIdSupportTicketIdRouteImport } from './routes/_app/o.$orgId.support.$ticketId'
import { Route as AppOOrgIdProjectsProjectIdIndexRouteImport } from './routes/_app/o.$orgId.projects.$projectId.index'
import { Route as AppOOrgIdProjectsProjectIdDatabasesIndexRouteImport } from './routes/_app/o.$orgId.projects.$projectId.databases.index'
import { Route as AppOOrgIdProjectsProjectIdDatabasesDatabaseIdRouteImport } from './routes/_app/o.$orgId.projects.$projectId.databases.$databaseId'
import { Route as AppOOrgIdProjectsProjectIdServicesServiceIdRouteImport } from './routes/_app/o.$orgId.projects.$projectId.services.$serviceId'
import { Route as AppOOrgIdProjectsProjectIdServicesServiceIdIndexRouteImport } from './routes/_app/o.$orgId.projects.$projectId.services.$serviceId.index'
import { Route as AppOOrgIdProjectsProjectIdServicesServiceIdConsoleRouteImport } from './routes/_app/o.$orgId.projects.$projectId.services.$serviceId.console'
import { Route as AppOOrgIdProjectsProjectIdServicesServiceIdDeploymentsRouteImport } from './routes/_app/o.$orgId.projects.$projectId.services.$serviceId.deployments'
import { Route as AppOOrgIdProjectsProjectIdServicesServiceIdDomainsRouteImport } from './routes/_app/o.$orgId.projects.$projectId.services.$serviceId.domains'
import { Route as AppOOrgIdProjectsProjectIdServicesServiceIdLogsRouteImport } from './routes/_app/o.$orgId.projects.$projectId.services.$serviceId.logs'
import { Route as AppOOrgIdProjectsProjectIdServicesServiceIdSettingsRouteImport } from './routes/_app/o.$orgId.projects.$projectId.services.$serviceId.settings'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const PublicCloseAccountRoute = PublicCloseAccountRouteImport.update({
  id: '/close-account',
  path: '/close-account',
  getParentRoute: () => PublicRoute,
} as any)
const PublicForgotPasswordRoute = PublicForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => PublicRoute,
} as any)
const PublicInvitationRoute = PublicInvitationRouteImport.update({
  id: '/invitation',
  path: '/invitation',
  getParentRoute: () => PublicRoute,
} as any)
const PublicRegisterRoute = PublicRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => PublicRoute,
} as any)
const PublicResetPasswordRoute = PublicResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSignInRoute = PublicSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => PublicRoute,
} as any)
const PublicTwoFactorRoute = PublicTwoFactorRouteImport.update({
  id: '/two-factor',
  path: '/two-factor',
  getParentRoute: () => PublicRoute,
} as any)
const PublicVerifyEmailRoute = PublicVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => PublicRoute,
} as any)
const AppAccountSecurityRoute = AppAccountSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AppAccountRoute,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminOrgIdRoute = AppAdminOrgIdRouteImport.update({
  id: '/$orgId',
  path: '/$orgId',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminAbuseRoute = AppAdminAbuseRouteImport.update({
  id: '/abuse',
  path: '/abuse',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminAccessRoute = AppAdminAccessRouteImport.update({
  id: '/access',
  path: '/access',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminActivityRoute = AppAdminActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminBuildsRoute = AppAdminBuildsRouteImport.update({
  id: '/builds',
  path: '/builds',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminCertificatesRoute = AppAdminCertificatesRouteImport.update({
  id: '/certificates',
  path: '/certificates',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminConsoleRoute = AppAdminConsoleRouteImport.update({
  id: '/console',
  path: '/console',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminDatabasesRoute = AppAdminDatabasesRouteImport.update({
  id: '/databases',
  path: '/databases',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminFleetRoute = AppAdminFleetRouteImport.update({
  id: '/fleet',
  path: '/fleet',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminInvoicesRoute = AppAdminInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminJobsRoute = AppAdminJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminOrganisationsRoute = AppAdminOrganisationsRouteImport.update({
  id: '/organisations',
  path: '/organisations',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminPricesRoute = AppAdminPricesRouteImport.update({
  id: '/prices',
  path: '/prices',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminRevenueRoute = AppAdminRevenueRouteImport.update({
  id: '/revenue',
  path: '/revenue',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminServicesRoute = AppAdminServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminStaffRoute = AppAdminStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminTokensRoute = AppAdminTokensRouteImport.update({
  id: '/tokens',
  path: '/tokens',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminVolumesRoute = AppAdminVolumesRouteImport.update({
  id: '/volumes',
  path: '/volumes',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminWebhooksRoute = AppAdminWebhooksRouteImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppConnectionsGithubRoute = AppConnectionsGithubRouteImport.update({
  id: '/connections/github',
  path: '/connections/github',
  getParentRoute: () => AppRoute,
} as any)
const AppOOrgIdRoute = AppOOrgIdRouteImport.update({
  id: '/o/$orgId',
  path: '/o/$orgId',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminTicketsIndexRoute = AppAdminTicketsIndexRouteImport.update({
  id: '/tickets/',
  path: '/tickets/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminTicketsTicketIdRoute = AppAdminTicketsTicketIdRouteImport.update({
  id: '/tickets/$ticketId',
  path: '/tickets/$ticketId',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminUsersIndexRoute = AppAdminUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminUsersUserIdRoute = AppAdminUsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppOOrgIdIndexRoute = AppOOrgIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOOrgIdRoute,
} as any)
const AppOOrgIdAuditRoute = AppOOrgIdAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppOOrgIdRoute,
} as any)
const AppOOrgIdBillingRoute = AppOOrgIdBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppOOrgIdRoute,
} as any)
const AppOOrgIdConnectionsRoute = AppOOrgIdConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => AppOOrgIdRoute,
} as any)
const AppOOrgIdMembersRoute = AppOOrgIdMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AppOOrgIdRoute,
} as any)
const AppOOrgIdNotificationsRoute = AppOOrgIdNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppOOrgIdRoute,
} as any)
const AppOOrgIdOrderRoute = AppOOrgIdOrderRouteImport.update({
  id: '/order',
  path: '/order',
  getParentRoute: () => AppOOrgIdRoute,
} as any)
const AppOOrgIdSettingsRoute = AppOOrgIdSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppOOrgIdRoute,
} as any)
const AppOOrgIdTokensRoute = AppOOrgIdTokensRouteImport.update({
  id: '/tokens',
  path: '/tokens',
  getParentRoute: () => AppOOrgIdRoute,
} as any)
const AppOOrgIdBillingIndexRoute = AppOOrgIdBillingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOOrgIdBillingRoute,
} as any)
const AppOOrgIdBillingCreditRoute = AppOOrgIdBillingCreditRouteImport.update({
  id: '/credit',
  path: '/credit',
  getParentRoute: () => AppOOrgIdBillingRoute,
} as any)
const AppOOrgIdBillingInvoicesRoute =
  AppOOrgIdBillingInvoicesRouteImport.update({
    id: '/invoices',
    path: '/invoices',
    getParentRoute: () => AppOOrgIdBillingRoute,
  } as any)
const AppOOrgIdProjectsIndexRoute = AppOOrgIdProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppOOrgIdRoute,
} as any)
const AppOOrgIdSupportIndexRoute = AppOOrgIdSupportIndexRouteImport.update({
  id: '/support/',
  path: '/support/',
  getParentRoute: () => AppOOrgIdRoute,
} as any)
const AppOOrgIdSupportTicketIdRoute =
  AppOOrgIdSupportTicketIdRouteImport.update({
    id: '/support/$ticketId',
    path: '/support/$ticketId',
    getParentRoute: () => AppOOrgIdRoute,
  } as any)
const AppOOrgIdProjectsProjectIdIndexRoute =
  AppOOrgIdProjectsProjectIdIndexRouteImport.update({
    id: '/projects/$projectId/',
    path: '/projects/$projectId/',
    getParentRoute: () => AppOOrgIdRoute,
  } as any)
const AppOOrgIdProjectsProjectIdDatabasesIndexRoute =
  AppOOrgIdProjectsProjectIdDatabasesIndexRouteImport.update({
    id: '/projects/$projectId/databases/',
    path: '/projects/$projectId/databases/',
    getParentRoute: () => AppOOrgIdRoute,
  } as any)
const AppOOrgIdProjectsProjectIdDatabasesDatabaseIdRoute =
  AppOOrgIdProjectsProjectIdDatabasesDatabaseIdRouteImport.update({
    id: '/projects/$projectId/databases/$databaseId',
    path: '/projects/$projectId/databases/$databaseId',
    getParentRoute: () => AppOOrgIdRoute,
  } as any)
const AppOOrgIdProjectsProjectIdServicesServiceIdRoute =
  AppOOrgIdProjectsProjectIdServicesServiceIdRouteImport.update({
    id: '/projects/$projectId/services/$serviceId',
    path: '/projects/$projectId/services/$serviceId',
    getParentRoute: () => AppOOrgIdRoute,
  } as any)
const AppOOrgIdProjectsProjectIdServicesServiceIdIndexRoute =
  AppOOrgIdProjectsProjectIdServicesServiceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppOOrgIdProjectsProjectIdServicesServiceIdRoute,
  } as any)
const AppOOrgIdProjectsProjectIdServicesServiceIdConsoleRoute =
  AppOOrgIdProjectsProjectIdServicesServiceIdConsoleRouteImport.update({
    id: '/console',
    path: '/console',
    getParentRoute: () => AppOOrgIdProjectsProjectIdServicesServiceIdRoute,
  } as any)
const AppOOrgIdProjectsProjectIdServicesServiceIdDeploymentsRoute =
  AppOOrgIdProjectsProjectIdServicesServiceIdDeploymentsRouteImport.update({
    id: '/deployments',
    path: '/deployments',
    getParentRoute: () => AppOOrgIdProjectsProjectIdServicesServiceIdRoute,
  } as any)
const AppOOrgIdProjectsProjectIdServicesServiceIdDomainsRoute =
  AppOOrgIdProjectsProjectIdServicesServiceIdDomainsRouteImport.update({
    id: '/domains',
    path: '/domains',
    getParentRoute: () => AppOOrgIdProjectsProjectIdServicesServiceIdRoute,
  } as any)
const AppOOrgIdProjectsProjectIdServicesServiceIdLogsRoute =
  AppOOrgIdProjectsProjectIdServicesServiceIdLogsRouteImport.update({
    id: '/logs',
    path: '/logs',
    getParentRoute: () => AppOOrgIdProjectsProjectIdServicesServiceIdRoute,
  } as any)
const AppOOrgIdProjectsProjectIdServicesServiceIdSettingsRoute =
  AppOOrgIdProjectsProjectIdServicesServiceIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AppOOrgIdProjectsProjectIdServicesServiceIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/account': typeof AppAccountRouteWithChildren
  '/admin': typeof AppAdminRouteWithChildren
  '/close-account': typeof PublicCloseAccountRoute
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/invitation': typeof PublicInvitationRoute
  '/register': typeof PublicRegisterRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/sign-in': typeof PublicSignInRoute
  '/two-factor': typeof PublicTwoFactorRoute
  '/verify-email': typeof PublicVerifyEmailRoute
  '/account/security': typeof AppAccountSecurityRoute
  '/admin/$orgId': typeof AppAdminOrgIdRoute
  '/admin/abuse': typeof AppAdminAbuseRoute
  '/admin/access': typeof AppAdminAccessRoute
  '/admin/activity': typeof AppAdminActivityRoute
  '/admin/builds': typeof AppAdminBuildsRoute
  '/admin/certificates': typeof AppAdminCertificatesRoute
  '/admin/console': typeof AppAdminConsoleRoute
  '/admin/databases': typeof AppAdminDatabasesRoute
  '/admin/fleet': typeof AppAdminFleetRoute
  '/admin/invoices': typeof AppAdminInvoicesRoute
  '/admin/jobs': typeof AppAdminJobsRoute
  '/admin/organisations': typeof AppAdminOrganisationsRoute
  '/admin/prices': typeof AppAdminPricesRoute
  '/admin/revenue': typeof AppAdminRevenueRoute
  '/admin/services': typeof AppAdminServicesRoute
  '/admin/staff': typeof AppAdminStaffRoute
  '/admin/tokens': typeof AppAdminTokensRoute
  '/admin/volumes': typeof AppAdminVolumesRoute
  '/admin/webhooks': typeof AppAdminWebhooksRoute
  '/connections/github': typeof AppConnectionsGithubRoute
  '/o/$orgId': typeof AppOOrgIdRouteWithChildren
  '/admin/': typeof AppAdminIndexRoute
  '/admin/tickets/$ticketId': typeof AppAdminTicketsTicketIdRoute
  '/admin/users/$userId': typeof AppAdminUsersUserIdRoute
  '/o/$orgId/audit': typeof AppOOrgIdAuditRoute
  '/o/$orgId/billing': typeof AppOOrgIdBillingRouteWithChildren
  '/o/$orgId/connections': typeof AppOOrgIdConnectionsRoute
  '/o/$orgId/members': typeof AppOOrgIdMembersRoute
  '/o/$orgId/notifications': typeof AppOOrgIdNotificationsRoute
  '/o/$orgId/order': typeof AppOOrgIdOrderRoute
  '/o/$orgId/settings': typeof AppOOrgIdSettingsRoute
  '/o/$orgId/tokens': typeof AppOOrgIdTokensRoute
  '/admin/tickets/': typeof AppAdminTicketsIndexRoute
  '/admin/users/': typeof AppAdminUsersIndexRoute
  '/o/$orgId/': typeof AppOOrgIdIndexRoute
  '/o/$orgId/billing/credit': typeof AppOOrgIdBillingCreditRoute
  '/o/$orgId/billing/invoices': typeof AppOOrgIdBillingInvoicesRoute
  '/o/$orgId/support/$ticketId': typeof AppOOrgIdSupportTicketIdRoute
  '/o/$orgId/billing/': typeof AppOOrgIdBillingIndexRoute
  '/o/$orgId/projects/': typeof AppOOrgIdProjectsIndexRoute
  '/o/$orgId/support/': typeof AppOOrgIdSupportIndexRoute
  '/o/$orgId/projects/$projectId/': typeof AppOOrgIdProjectsProjectIdIndexRoute
  '/o/$orgId/projects/$projectId/databases/$databaseId': typeof AppOOrgIdProjectsProjectIdDatabasesDatabaseIdRoute
  '/o/$orgId/projects/$projectId/services/$serviceId': typeof AppOOrgIdProjectsProjectIdServicesServiceIdRouteWithChildren
  '/o/$orgId/projects/$projectId/databases/': typeof AppOOrgIdProjectsProjectIdDatabasesIndexRoute
  '/o/$orgId/projects/$projectId/services/$serviceId/console': typeof AppOOrgIdProjectsProjectIdServicesServiceIdConsoleRoute
  '/o/$orgId/projects/$projectId/services/$serviceId/deployments': typeof AppOOrgIdProjectsProjectIdServicesServiceIdDeploymentsRoute
  '/o/$orgId/projects/$projectId/services/$serviceId/domains': typeof AppOOrgIdProjectsProjectIdServicesServiceIdDomainsRoute
  '/o/$orgId/projects/$projectId/services/$serviceId/logs': typeof AppOOrgIdProjectsProjectIdServicesServiceIdLogsRoute
  '/o/$orgId/projects/$projectId/services/$serviceId/settings': typeof AppOOrgIdProjectsProjectIdServicesServiceIdSettingsRoute
  '/o/$orgId/projects/$projectId/services/$serviceId/': typeof AppOOrgIdProjectsProjectIdServicesServiceIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/account': typeof AppAccountRouteWithChildren
  '/close-account': typeof PublicCloseAccountRoute
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/invitation': typeof PublicInvitationRoute
  '/register': typeof PublicRegisterRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/sign-in': typeof PublicSignInRoute
  '/two-factor': typeof PublicTwoFactorRoute
  '/verify-email': typeof PublicVerifyEmailRoute
  '/account/security': typeof AppAccountSecurityRoute
  '/admin/$orgId': typeof AppAdminOrgIdRoute
  '/admin/abuse': typeof AppAdminAbuseRoute
  '/admin/access': typeof AppAdminAccessRoute
  '/admin/activity': typeof AppAdminActivityRoute
  '/admin/builds': typeof AppAdminBuildsRoute
  '/admin/certificates': typeof AppAdminCertificatesRoute
  '/admin/console': typeof AppAdminConsoleRoute
  '/admin/databases': typeof AppAdminDatabasesRoute
  '/admin/fleet': typeof AppAdminFleetRoute
  '/admin/invoices': typeof AppAdminInvoicesRoute
  '/admin/jobs': typeof AppAdminJobsRoute
  '/admin/organisations': typeof AppAdminOrganisationsRoute
  '/admin/prices': typeof AppAdminPricesRoute
  '/admin/revenue': typeof AppAdminRevenueRoute
  '/admin/services': typeof AppAdminServicesRoute
  '/admin/staff': typeof AppAdminStaffRoute
  '/admin/tokens': typeof AppAdminTokensRoute
  '/admin/volumes': typeof AppAdminVolumesRoute
  '/admin/webhooks': typeof AppAdminWebhooksRoute
  '/connections/github': typeof AppConnectionsGithubRoute
  '/admin': typeof AppAdminIndexRoute
  '/admin/tickets/$ticketId': typeof AppAdminTicketsTicketIdRoute
  '/admin/users/$userId': typeof AppAdminUsersUserIdRoute
  '/o/$orgId/audit': typeof AppOOrgIdAuditRoute
  '/o/$orgId/connections': typeof AppOOrgIdConnectionsRoute
  '/o/$orgId/members': typeof AppOOrgIdMembersRoute
  '/o/$orgId/notifications': typeof AppOOrgIdNotificationsRoute
  '/o/$orgId/order': typeof AppOOrgIdOrderRoute
  '/o/$orgId/settings': typeof AppOOrgIdSettingsRoute
  '/o/$orgId/tokens': typeof AppOOrgIdTokensRoute
  '/admin/tickets': typeof AppAdminTicketsIndexRoute
  '/admin/users': typeof AppAdminUsersIndexRoute
  '/o/$orgId': typeof AppOOrgIdIndexRoute
  '/o/$orgId/billing/credit': typeof AppOOrgIdBillingCreditRoute
  '/o/$orgId/billing/invoices': typeof AppOOrgIdBillingInvoicesRoute
  '/o/$orgId/support/$ticketId': typeof AppOOrgIdSupportTicketIdRoute
  '/o/$orgId/billing': typeof AppOOrgIdBillingIndexRoute
  '/o/$orgId/projects': typeof AppOOrgIdProjectsIndexRoute
  '/o/$orgId/support': typeof AppOOrgIdSupportIndexRoute
  '/o/$orgId/projects/$projectId': typeof AppOOrgIdProjectsProjectIdIndexRoute
  '/o/$orgId/projects/$projectId/databases/$databaseId': typeof AppOOrgIdProjectsProjectIdDatabasesDatabaseIdRoute
  '/o/$orgId/projects/$projectId/databases': typeof AppOOrgIdProjectsProjectIdDatabasesIndexRoute
  '/o/$orgId/projects/$projectId/services/$serviceId/console': typeof AppOOrgIdProjectsProjectIdServicesServiceIdConsoleRoute
  '/o/$orgId/projects/$projectId/services/$serviceId/deployments': typeof AppOOrgIdProjectsProjectIdServicesServiceIdDeploymentsRoute
  '/o/$orgId/projects/$projectId/services/$serviceId/domains': typeof AppOOrgIdProjectsProjectIdServicesServiceIdDomainsRoute
  '/o/$orgId/projects/$projectId/services/$serviceId/logs': typeof AppOOrgIdProjectsProjectIdServicesServiceIdLogsRoute
  '/o/$orgId/projects/$projectId/services/$serviceId/settings': typeof AppOOrgIdProjectsProjectIdServicesServiceIdSettingsRoute
  '/o/$orgId/projects/$projectId/services/$serviceId': typeof AppOOrgIdProjectsProjectIdServicesServiceIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_app/account': typeof AppAccountRouteWithChildren
  '/_app/admin': typeof AppAdminRouteWithChildren
  '/_public/close-account': typeof PublicCloseAccountRoute
  '/_public/forgot-password': typeof PublicForgotPasswordRoute
  '/_public/invitation': typeof PublicInvitationRoute
  '/_public/register': typeof PublicRegisterRoute
  '/_public/reset-password': typeof PublicResetPasswordRoute
  '/_public/sign-in': typeof PublicSignInRoute
  '/_public/two-factor': typeof PublicTwoFactorRoute
  '/_public/verify-email': typeof PublicVerifyEmailRoute
  '/_app/': typeof AppIndexRoute
  '/_app/account/security': typeof AppAccountSecurityRoute
  '/_app/admin/$orgId': typeof AppAdminOrgIdRoute
  '/_app/admin/abuse': typeof AppAdminAbuseRoute
  '/_app/admin/access': typeof AppAdminAccessRoute
  '/_app/admin/activity': typeof AppAdminActivityRoute
  '/_app/admin/builds': typeof AppAdminBuildsRoute
  '/_app/admin/certificates': typeof AppAdminCertificatesRoute
  '/_app/admin/console': typeof AppAdminConsoleRoute
  '/_app/admin/databases': typeof AppAdminDatabasesRoute
  '/_app/admin/fleet': typeof AppAdminFleetRoute
  '/_app/admin/invoices': typeof AppAdminInvoicesRoute
  '/_app/admin/jobs': typeof AppAdminJobsRoute
  '/_app/admin/organisations': typeof AppAdminOrganisationsRoute
  '/_app/admin/prices': typeof AppAdminPricesRoute
  '/_app/admin/revenue': typeof AppAdminRevenueRoute
  '/_app/admin/services': typeof AppAdminServicesRoute
  '/_app/admin/staff': typeof AppAdminStaffRoute
  '/_app/admin/tokens': typeof AppAdminTokensRoute
  '/_app/admin/volumes': typeof AppAdminVolumesRoute
  '/_app/admin/webhooks': typeof AppAdminWebhooksRoute
  '/_app/connections/github': typeof AppConnectionsGithubRoute
  '/_app/o/$orgId': typeof AppOOrgIdRouteWithChildren
  '/_app/admin/': typeof AppAdminIndexRoute
  '/_app/admin/tickets/$ticketId': typeof AppAdminTicketsTicketIdRoute
  '/_app/admin/users/$userId': typeof AppAdminUsersUserIdRoute
  '/_app/o/$orgId/audit': typeof AppOOrgIdAuditRoute
  '/_app/o/$orgId/billing': typeof AppOOrgIdBillingRouteWithChildren
  '/_app/o/$orgId/connections': typeof AppOOrgIdConnectionsRoute
  '/_app/o/$orgId/members': typeof AppOOrgIdMembersRoute
  '/_app/o/$orgId/notifications': typeof AppOOrgIdNotificationsRoute
  '/_app/o/$orgId/order': typeof AppOOrgIdOrderRoute
  '/_app/o/$orgId/settings': typeof AppOOrgIdSettingsRoute
  '/_app/o/$orgId/tokens': typeof AppOOrgIdTokensRoute
  '/_app/admin/tickets/': typeof AppAdminTicketsIndexRoute
  '/_app/admin/users/': typeof AppAdminUsersIndexRoute
  '/_app/o/$orgId/': typeof AppOOrgIdIndexRoute
  '/_app/o/$orgId/billing/credit': typeof AppOOrgIdBillingCreditRoute
  '/_app/o/$orgId/billing/invoices': typeof AppOOrgIdBillingInvoicesRoute
  '/_app/o/$orgId/support/$ticketId': typeof AppOOrgIdSupportTicketIdRoute
  '/_app/o/$orgId/billing/': typeof AppOOrgIdBillingIndexRoute
  '/_app/o/$orgId/projects/': typeof AppOOrgIdProjectsIndexRoute
  '/_app/o/$orgId/support/': typeof AppOOrgIdSupportIndexRoute
  '/_app/o/$orgId/projects/$projectId/': typeof AppOOrgIdProjectsProjectIdIndexRoute
  '/_app/o/$orgId/projects/$projectId/databases/$databaseId': typeof AppOOrgIdProjectsProjectIdDatabasesDatabaseIdRoute
  '/_app/o/$orgId/projects/$projectId/services/$serviceId': typeof AppOOrgIdProjectsProjectIdServicesServiceIdRouteWithChildren
  '/_app/o/$orgId/projects/$projectId/databases/': typeof AppOOrgIdProjectsProjectIdDatabasesIndexRoute
  '/_app/o/$orgId/projects/$projectId/services/$serviceId/console': typeof AppOOrgIdProjectsProjectIdServicesServiceIdConsoleRoute
  '/_app/o/$orgId/projects/$projectId/services/$serviceId/deployments': typeof AppOOrgIdProjectsProjectIdServicesServiceIdDeploymentsRoute
  '/_app/o/$orgId/projects/$projectId/services/$serviceId/domains': typeof AppOOrgIdProjectsProjectIdServicesServiceIdDomainsRoute
  '/_app/o/$orgId/projects/$projectId/services/$serviceId/logs': typeof AppOOrgIdProjectsProjectIdServicesServiceIdLogsRoute
  '/_app/o/$orgId/projects/$projectId/services/$serviceId/settings': typeof AppOOrgIdProjectsProjectIdServicesServiceIdSettingsRoute
  '/_app/o/$orgId/projects/$projectId/services/$serviceId/': typeof AppOOrgIdProjectsProjectIdServicesServiceIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/admin'
    | '/close-account'
    | '/forgot-password'
    | '/invitation'
    | '/register'
    | '/reset-password'
    | '/sign-in'
    | '/two-factor'
    | '/verify-email'
    | '/account/security'
    | '/admin/$orgId'
    | '/admin/abuse'
    | '/admin/access'
    | '/admin/activity'
    | '/admin/builds'
    | '/admin/certificates'
    | '/admin/console'
    | '/admin/databases'
    | '/admin/fleet'
    | '/admin/invoices'
    | '/admin/jobs'
    | '/admin/organisations'
    | '/admin/prices'
    | '/admin/revenue'
    | '/admin/services'
    | '/admin/staff'
    | '/admin/tokens'
    | '/admin/volumes'
    | '/admin/webhooks'
    | '/connections/github'
    | '/o/$orgId'
    | '/admin/'
    | '/admin/tickets/$ticketId'
    | '/admin/users/$userId'
    | '/o/$orgId/audit'
    | '/o/$orgId/billing'
    | '/o/$orgId/connections'
    | '/o/$orgId/members'
    | '/o/$orgId/notifications'
    | '/o/$orgId/order'
    | '/o/$orgId/settings'
    | '/o/$orgId/tokens'
    | '/admin/tickets/'
    | '/admin/users/'
    | '/o/$orgId/'
    | '/o/$orgId/billing/credit'
    | '/o/$orgId/billing/invoices'
    | '/o/$orgId/support/$ticketId'
    | '/o/$orgId/billing/'
    | '/o/$orgId/projects/'
    | '/o/$orgId/support/'
    | '/o/$orgId/projects/$projectId/'
    | '/o/$orgId/projects/$projectId/databases/$databaseId'
    | '/o/$orgId/projects/$projectId/services/$serviceId'
    | '/o/$orgId/projects/$projectId/databases/'
    | '/o/$orgId/projects/$projectId/services/$serviceId/console'
    | '/o/$orgId/projects/$projectId/services/$serviceId/deployments'
    | '/o/$orgId/projects/$projectId/services/$serviceId/domains'
    | '/o/$orgId/projects/$projectId/services/$serviceId/logs'
    | '/o/$orgId/projects/$projectId/services/$serviceId/settings'
    | '/o/$orgId/projects/$projectId/services/$serviceId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/close-account'
    | '/forgot-password'
    | '/invitation'
    | '/register'
    | '/reset-password'
    | '/sign-in'
    | '/two-factor'
    | '/verify-email'
    | '/account/security'
    | '/admin/$orgId'
    | '/admin/abuse'
    | '/admin/access'
    | '/admin/activity'
    | '/admin/builds'
    | '/admin/certificates'
    | '/admin/console'
    | '/admin/databases'
    | '/admin/fleet'
    | '/admin/invoices'
    | '/admin/jobs'
    | '/admin/organisations'
    | '/admin/prices'
    | '/admin/revenue'
    | '/admin/services'
    | '/admin/staff'
    | '/admin/tokens'
    | '/admin/volumes'
    | '/admin/webhooks'
    | '/connections/github'
    | '/admin'
    | '/admin/tickets/$ticketId'
    | '/admin/users/$userId'
    | '/o/$orgId/audit'
    | '/o/$orgId/connections'
    | '/o/$orgId/members'
    | '/o/$orgId/notifications'
    | '/o/$orgId/order'
    | '/o/$orgId/settings'
    | '/o/$orgId/tokens'
    | '/admin/tickets'
    | '/admin/users'
    | '/o/$orgId'
    | '/o/$orgId/billing/credit'
    | '/o/$orgId/billing/invoices'
    | '/o/$orgId/support/$ticketId'
    | '/o/$orgId/billing'
    | '/o/$orgId/projects'
    | '/o/$orgId/support'
    | '/o/$orgId/projects/$projectId'
    | '/o/$orgId/projects/$projectId/databases/$databaseId'
    | '/o/$orgId/projects/$projectId/databases'
    | '/o/$orgId/projects/$projectId/services/$serviceId/console'
    | '/o/$orgId/projects/$projectId/services/$serviceId/deployments'
    | '/o/$orgId/projects/$projectId/services/$serviceId/domains'
    | '/o/$orgId/projects/$projectId/services/$serviceId/logs'
    | '/o/$orgId/projects/$projectId/services/$serviceId/settings'
    | '/o/$orgId/projects/$projectId/services/$serviceId'
  id:
    | '__root__'
    | '/_app'
    | '/_public'
    | '/_app/account'
    | '/_app/admin'
    | '/_public/close-account'
    | '/_public/forgot-password'
    | '/_public/invitation'
    | '/_public/register'
    | '/_public/reset-password'
    | '/_public/sign-in'
    | '/_public/two-factor'
    | '/_public/verify-email'
    | '/_app/'
    | '/_app/account/security'
    | '/_app/admin/$orgId'
    | '/_app/admin/abuse'
    | '/_app/admin/access'
    | '/_app/admin/activity'
    | '/_app/admin/builds'
    | '/_app/admin/certificates'
    | '/_app/admin/console'
    | '/_app/admin/databases'
    | '/_app/admin/fleet'
    | '/_app/admin/invoices'
    | '/_app/admin/jobs'
    | '/_app/admin/organisations'
    | '/_app/admin/prices'
    | '/_app/admin/revenue'
    | '/_app/admin/services'
    | '/_app/admin/staff'
    | '/_app/admin/tokens'
    | '/_app/admin/volumes'
    | '/_app/admin/webhooks'
    | '/_app/connections/github'
    | '/_app/o/$orgId'
    | '/_app/admin/'
    | '/_app/admin/tickets/$ticketId'
    | '/_app/admin/users/$userId'
    | '/_app/o/$orgId/audit'
    | '/_app/o/$orgId/billing'
    | '/_app/o/$orgId/connections'
    | '/_app/o/$orgId/members'
    | '/_app/o/$orgId/notifications'
    | '/_app/o/$orgId/order'
    | '/_app/o/$orgId/settings'
    | '/_app/o/$orgId/tokens'
    | '/_app/admin/tickets/'
    | '/_app/admin/users/'
    | '/_app/o/$orgId/'
    | '/_app/o/$orgId/billing/credit'
    | '/_app/o/$orgId/billing/invoices'
    | '/_app/o/$orgId/support/$ticketId'
    | '/_app/o/$orgId/billing/'
    | '/_app/o/$orgId/projects/'
    | '/_app/o/$orgId/support/'
    | '/_app/o/$orgId/projects/$projectId/'
    | '/_app/o/$orgId/projects/$projectId/databases/$databaseId'
    | '/_app/o/$orgId/projects/$projectId/services/$serviceId'
    | '/_app/o/$orgId/projects/$projectId/databases/'
    | '/_app/o/$orgId/projects/$projectId/services/$serviceId/console'
    | '/_app/o/$orgId/projects/$projectId/services/$serviceId/deployments'
    | '/_app/o/$orgId/projects/$projectId/services/$serviceId/domains'
    | '/_app/o/$orgId/projects/$projectId/services/$serviceId/logs'
    | '/_app/o/$orgId/projects/$projectId/services/$serviceId/settings'
    | '/_app/o/$orgId/projects/$projectId/services/$serviceId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_public/close-account': {
      id: '/_public/close-account'
      path: '/close-account'
      fullPath: '/close-account'
      preLoaderRoute: typeof PublicCloseAccountRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/forgot-password': {
      id: '/_public/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof PublicForgotPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/invitation': {
      id: '/_public/invitation'
      path: '/invitation'
      fullPath: '/invitation'
      preLoaderRoute: typeof PublicInvitationRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/register': {
      id: '/_public/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof PublicRegisterRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/reset-password': {
      id: '/_public/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof PublicResetPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/sign-in': {
      id: '/_public/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof PublicSignInRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/two-factor': {
      id: '/_public/two-factor'
      path: '/two-factor'
      fullPath: '/two-factor'
      preLoaderRoute: typeof PublicTwoFactorRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/verify-email': {
      id: '/_public/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof PublicVerifyEmailRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_app/account/security': {
      id: '/_app/account/security'
      path: '/security'
      fullPath: '/account/security'
      preLoaderRoute: typeof AppAccountSecurityRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/_app/admin/': {
      id: '/_app/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/$orgId': {
      id: '/_app/admin/$orgId'
      path: '/$orgId'
      fullPath: '/admin/$orgId'
      preLoaderRoute: typeof AppAdminOrgIdRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/abuse': {
      id: '/_app/admin/abuse'
      path: '/abuse'
      fullPath: '/admin/abuse'
      preLoaderRoute: typeof AppAdminAbuseRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/access': {
      id: '/_app/admin/access'
      path: '/access'
      fullPath: '/admin/access'
      preLoaderRoute: typeof AppAdminAccessRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/activity': {
      id: '/_app/admin/activity'
      path: '/activity'
      fullPath: '/admin/activity'
      preLoaderRoute: typeof AppAdminActivityRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/builds': {
      id: '/_app/admin/builds'
      path: '/builds'
      fullPath: '/admin/builds'
      preLoaderRoute: typeof AppAdminBuildsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/certificates': {
      id: '/_app/admin/certificates'
      path: '/certificates'
      fullPath: '/admin/certificates'
      preLoaderRoute: typeof AppAdminCertificatesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/console': {
      id: '/_app/admin/console'
      path: '/console'
      fullPath: '/admin/console'
      preLoaderRoute: typeof AppAdminConsoleRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/databases': {
      id: '/_app/admin/databases'
      path: '/databases'
      fullPath: '/admin/databases'
      preLoaderRoute: typeof AppAdminDatabasesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/fleet': {
      id: '/_app/admin/fleet'
      path: '/fleet'
      fullPath: '/admin/fleet'
      preLoaderRoute: typeof AppAdminFleetRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/invoices': {
      id: '/_app/admin/invoices'
      path: '/invoices'
      fullPath: '/admin/invoices'
      preLoaderRoute: typeof AppAdminInvoicesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/jobs': {
      id: '/_app/admin/jobs'
      path: '/jobs'
      fullPath: '/admin/jobs'
      preLoaderRoute: typeof AppAdminJobsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/organisations': {
      id: '/_app/admin/organisations'
      path: '/organisations'
      fullPath: '/admin/organisations'
      preLoaderRoute: typeof AppAdminOrganisationsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/prices': {
      id: '/_app/admin/prices'
      path: '/prices'
      fullPath: '/admin/prices'
      preLoaderRoute: typeof AppAdminPricesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/revenue': {
      id: '/_app/admin/revenue'
      path: '/revenue'
      fullPath: '/admin/revenue'
      preLoaderRoute: typeof AppAdminRevenueRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/services': {
      id: '/_app/admin/services'
      path: '/services'
      fullPath: '/admin/services'
      preLoaderRoute: typeof AppAdminServicesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/staff': {
      id: '/_app/admin/staff'
      path: '/staff'
      fullPath: '/admin/staff'
      preLoaderRoute: typeof AppAdminStaffRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/tokens': {
      id: '/_app/admin/tokens'
      path: '/tokens'
      fullPath: '/admin/tokens'
      preLoaderRoute: typeof AppAdminTokensRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/volumes': {
      id: '/_app/admin/volumes'
      path: '/volumes'
      fullPath: '/admin/volumes'
      preLoaderRoute: typeof AppAdminVolumesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/webhooks': {
      id: '/_app/admin/webhooks'
      path: '/webhooks'
      fullPath: '/admin/webhooks'
      preLoaderRoute: typeof AppAdminWebhooksRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/connections/github': {
      id: '/_app/connections/github'
      path: '/connections/github'
      fullPath: '/connections/github'
      preLoaderRoute: typeof AppConnectionsGithubRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/o/$orgId': {
      id: '/_app/o/$orgId'
      path: '/o/$orgId'
      fullPath: '/o/$orgId'
      preLoaderRoute: typeof AppOOrgIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/tickets/': {
      id: '/_app/admin/tickets/'
      path: '/tickets'
      fullPath: '/admin/tickets/'
      preLoaderRoute: typeof AppAdminTicketsIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/tickets/$ticketId': {
      id: '/_app/admin/tickets/$ticketId'
      path: '/tickets/$ticketId'
      fullPath: '/admin/tickets/$ticketId'
      preLoaderRoute: typeof AppAdminTicketsTicketIdRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/users/': {
      id: '/_app/admin/users/'
      path: '/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AppAdminUsersIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/users/$userId': {
      id: '/_app/admin/users/$userId'
      path: '/users/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof AppAdminUsersUserIdRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/o/$orgId/': {
      id: '/_app/o/$orgId/'
      path: '/'
      fullPath: '/o/$orgId/'
      preLoaderRoute: typeof AppOOrgIdIndexRouteImport
      parentRoute: typeof AppOOrgIdRoute
    }
    '/_app/o/$orgId/audit': {
      id: '/_app/o/$orgId/audit'
      path: '/audit'
      fullPath: '/o/$orgId/audit'
      preLoaderRoute: typeof AppOOrgIdAuditRouteImport
      parentRoute: typeof AppOOrgIdRoute
    }
    '/_app/o/$orgId/billing': {
      id: '/_app/o/$orgId/billing'
      path: '/billing'
      fullPath: '/o/$orgId/billing'
      preLoaderRoute: typeof AppOOrgIdBillingRouteImport
      parentRoute: typeof AppOOrgIdRoute
    }
    '/_app/o/$orgId/connections': {
      id: '/_app/o/$orgId/connections'
      path: '/connections'
      fullPath: '/o/$orgId/connections'
      preLoaderRoute: typeof AppOOrgIdConnectionsRouteImport
      parentRoute: typeof AppOOrgIdRoute
    }
    '/_app/o/$orgId/members': {
      id: '/_app/o/$orgId/members'
      path: '/members'
      fullPath: '/o/$orgId/members'
      preLoaderRoute: typeof AppOOrgIdMembersRouteImport
      parentRoute: typeof AppOOrgIdRoute
    }
    '/_app/o/$orgId/notifications': {
      id: '/_app/o/$orgId/notifications'
      path: '/notifications'
      fullPath: '/o/$orgId/notifications'
      preLoaderRoute: typeof AppOOrgIdNotificationsRouteImport
      parentRoute: typeof AppOOrgIdRoute
    }
    '/_app/o/$orgId/order': {
      id: '/_app/o/$orgId/order'
      path: '/order'
      fullPath: '/o/$orgId/order'
      preLoaderRoute: typeof AppOOrgIdOrderRouteImport
      parentRoute: typeof AppOOrgIdRoute
    }
    '/_app/o/$orgId/settings': {
      id: '/_app/o/$orgId/settings'
      path: '/settings'
      fullPath: '/o/$orgId/settings'
      preLoaderRoute: typeof AppOOrgIdSettingsRouteImport
      parentRoute: typeof AppOOrgIdRoute
    }
    '/_app/o/$orgId/tokens': {
      id: '/_app/o/$orgId/tokens'
      path: '/tokens'
      fullPath: '/o/$orgId/tokens'
      preLoaderRoute: typeof AppOOrgIdTokensRouteImport
      parentRoute: typeof AppOOrgIdRoute
    }
    '/_app/o/$orgId/billing/': {
      id: '/_app/o/$orgId/billing/'
      path: '/'
      fullPath: '/o/$orgId/billing/'
      preLoaderRoute: typeof AppOOrgIdBillingIndexRouteImport
      parentRoute: typeof AppOOrgIdBillingRoute
    }
    '/_app/o/$orgId/billing/credit': {
      id: '/_app/o/$orgId/billing/credit'
      path: '/credit'
      fullPath: '/o/$orgId/billing/credit'
      preLoaderRoute: typeof AppOOrgIdBillingCreditRouteImport
      parentRoute: typeof AppOOrgIdBillingRoute
    }
    '/_app/o/$orgId/billing/invoices': {
      id: '/_app/o/$orgId/billing/invoices'
      path: '/invoices'
      fullPath: '/o/$orgId/billing/invoices'
      preLoaderRoute: typeof AppOOrgIdBillingInvoicesRouteImport
      parentRoute: typeof AppOOrgIdBillingRoute
    }
    '/_app/o/$orgId/projects/': {
      id: '/_app/o/$orgId/projects/'
      path: '/projects'
      fullPath: '/o/$orgId/projects/'
      preLoaderRoute: typeof AppOOrgIdProjectsIndexRouteImport
      parentRoute: typeof AppOOrgIdRoute
    }
    '/_app/o/$orgId/support/': {
      id: '/_app/o/$orgId/support/'
      path: '/support'
      fullPath: '/o/$orgId/support/'
      preLoaderRoute: typeof AppOOrgIdSupportIndexRouteImport
      parentRoute: typeof AppOOrgIdRoute
    }
    '/_app/o/$orgId/support/$ticketId': {
      id: '/_app/o/$orgId/support/$ticketId'
      path: '/support/$ticketId'
      fullPath: '/o/$orgId/support/$ticketId'
      preLoaderRoute: typeof AppOOrgIdSupportTicketIdRouteImport
      parentRoute: typeof AppOOrgIdRoute
    }
    '/_app/o/$orgId/projects/$projectId/': {
      id: '/_app/o/$orgId/projects/$projectId/'
      path: '/projects/$projectId'
      fullPath: '/o/$orgId/projects/$projectId/'
      preLoaderRoute: typeof AppOOrgIdProjectsProjectIdIndexRouteImport
      parentRoute: typeof AppOOrgIdRoute
    }
    '/_app/o/$orgId/projects/$projectId/databases/': {
      id: '/_app/o/$orgId/projects/$projectId/databases/'
      path: '/projects/$projectId/databases'
      fullPath: '/o/$orgId/projects/$projectId/databases/'
      preLoaderRoute: typeof AppOOrgIdProjectsProjectIdDatabasesIndexRouteImport
      parentRoute: typeof AppOOrgIdRoute
    }
    '/_app/o/$orgId/projects/$projectId/databases/$databaseId': {
      id: '/_app/o/$orgId/projects/$projectId/databases/$databaseId'
      path: '/projects/$projectId/databases/$databaseId'
      fullPath: '/o/$orgId/projects/$projectId/databases/$databaseId'
      preLoaderRoute: typeof AppOOrgIdProjectsProjectIdDatabasesDatabaseIdRouteImport
      parentRoute: typeof AppOOrgIdRoute
    }
    '/_app/o/$orgId/projects/$projectId/services/$serviceId': {
      id: '/_app/o/$orgId/projects/$projectId/services/$serviceId'
      path: '/projects/$projectId/services/$serviceId'
      fullPath: '/o/$orgId/projects/$projectId/services/$serviceId'
      preLoaderRoute: typeof AppOOrgIdProjectsProjectIdServicesServiceIdRouteImport
      parentRoute: typeof AppOOrgIdRoute
    }
    '/_app/o/$orgId/projects/$projectId/services/$serviceId/': {
      id: '/_app/o/$orgId/projects/$projectId/services/$serviceId/'
      path: '/'
      fullPath: '/o/$orgId/projects/$projectId/services/$serviceId/'
      preLoaderRoute: typeof AppOOrgIdProjectsProjectIdServicesServiceIdIndexRouteImport
      parentRoute: typeof AppOOrgIdProjectsProjectIdServicesServiceIdRoute
    }
    '/_app/o/$orgId/projects/$projectId/services/$serviceId/console': {
      id: '/_app/o/$orgId/projects/$projectId/services/$serviceId/console'
      path: '/console'
      fullPath: '/o/$orgId/projects/$projectId/services/$serviceId/console'
      preLoaderRoute: typeof AppOOrgIdProjectsProjectIdServicesServiceIdConsoleRouteImport
      parentRoute: typeof AppOOrgIdProjectsProjectIdServicesServiceIdRoute
    }
    '/_app/o/$orgId/projects/$projectId/services/$serviceId/deployments': {
      id: '/_app/o/$orgId/projects/$projectId/services/$serviceId/deployments'
      path: '/deployments'
      fullPath: '/o/$orgId/projects/$projectId/services/$serviceId/deployments'
      preLoaderRoute: typeof AppOOrgIdProjectsProjectIdServicesServiceIdDeploymentsRouteImport
      parentRoute: typeof AppOOrgIdProjectsProjectIdServicesServiceIdRoute
    }
    '/_app/o/$orgId/projects/$projectId/services/$serviceId/domains': {
      id: '/_app/o/$orgId/projects/$projectId/services/$serviceId/domains'
      path: '/domains'
      fullPath: '/o/$orgId/projects/$projectId/services/$serviceId/domains'
      preLoaderRoute: typeof AppOOrgIdProjectsProjectIdServicesServiceIdDomainsRouteImport
      parentRoute: typeof AppOOrgIdProjectsProjectIdServicesServiceIdRoute
    }
    '/_app/o/$orgId/projects/$projectId/services/$serviceId/logs': {
      id: '/_app/o/$orgId/projects/$projectId/services/$serviceId/logs'
      path: '/logs'
      fullPath: '/o/$orgId/projects/$projectId/services/$serviceId/logs'
      preLoaderRoute: typeof AppOOrgIdProjectsProjectIdServicesServiceIdLogsRouteImport
      parentRoute: typeof AppOOrgIdProjectsProjectIdServicesServiceIdRoute
    }
    '/_app/o/$orgId/projects/$projectId/services/$serviceId/settings': {
      id: '/_app/o/$orgId/projects/$projectId/services/$serviceId/settings'
      path: '/settings'
      fullPath: '/o/$orgId/projects/$projectId/services/$serviceId/settings'
      preLoaderRoute: typeof AppOOrgIdProjectsProjectIdServicesServiceIdSettingsRouteImport
      parentRoute: typeof AppOOrgIdProjectsProjectIdServicesServiceIdRoute
    }
  }
}

interface AppAccountRouteChildren {
  AppAccountSecurityRoute: typeof AppAccountSecurityRoute
}

const AppAccountRouteChildren: AppAccountRouteChildren = {
  AppAccountSecurityRoute: AppAccountSecurityRoute,
}

const AppAccountRouteWithChildren = AppAccountRoute._addFileChildren(
  AppAccountRouteChildren,
)

interface AppAdminRouteChildren {
  AppAdminOrgIdRoute: typeof AppAdminOrgIdRoute
  AppAdminAbuseRoute: typeof AppAdminAbuseRoute
  AppAdminAccessRoute: typeof AppAdminAccessRoute
  AppAdminActivityRoute: typeof AppAdminActivityRoute
  AppAdminBuildsRoute: typeof AppAdminBuildsRoute
  AppAdminCertificatesRoute: typeof AppAdminCertificatesRoute
  AppAdminConsoleRoute: typeof AppAdminConsoleRoute
  AppAdminDatabasesRoute: typeof AppAdminDatabasesRoute
  AppAdminFleetRoute: typeof AppAdminFleetRoute
  AppAdminInvoicesRoute: typeof AppAdminInvoicesRoute
  AppAdminJobsRoute: typeof AppAdminJobsRoute
  AppAdminOrganisationsRoute: typeof AppAdminOrganisationsRoute
  AppAdminPricesRoute: typeof AppAdminPricesRoute
  AppAdminRevenueRoute: typeof AppAdminRevenueRoute
  AppAdminServicesRoute: typeof AppAdminServicesRoute
  AppAdminStaffRoute: typeof AppAdminStaffRoute
  AppAdminTokensRoute: typeof AppAdminTokensRoute
  AppAdminVolumesRoute: typeof AppAdminVolumesRoute
  AppAdminWebhooksRoute: typeof AppAdminWebhooksRoute
  AppAdminIndexRoute: typeof AppAdminIndexRoute
  AppAdminTicketsTicketIdRoute: typeof AppAdminTicketsTicketIdRoute
  AppAdminUsersUserIdRoute: typeof AppAdminUsersUserIdRoute
  AppAdminTicketsIndexRoute: typeof AppAdminTicketsIndexRoute
  AppAdminUsersIndexRoute: typeof AppAdminUsersIndexRoute
}

const AppAdminRouteChildren: AppAdminRouteChildren = {
  AppAdminOrgIdRoute: AppAdminOrgIdRoute,
  AppAdminAbuseRoute: AppAdminAbuseRoute,
  AppAdminAccessRoute: AppAdminAccessRoute,
  AppAdminActivityRoute: AppAdminActivityRoute,
  AppAdminBuildsRoute: AppAdminBuildsRoute,
  AppAdminCertificatesRoute: AppAdminCertificatesRoute,
  AppAdminConsoleRoute: AppAdminConsoleRoute,
  AppAdminDatabasesRoute: AppAdminDatabasesRoute,
  AppAdminFleetRoute: AppAdminFleetRoute,
  AppAdminInvoicesRoute: AppAdminInvoicesRoute,
  AppAdminJobsRoute: AppAdminJobsRoute,
  AppAdminOrganisationsRoute: AppAdminOrganisationsRoute,
  AppAdminPricesRoute: AppAdminPricesRoute,
  AppAdminRevenueRoute: AppAdminRevenueRoute,
  AppAdminServicesRoute: AppAdminServicesRoute,
  AppAdminStaffRoute: AppAdminStaffRoute,
  AppAdminTokensRoute: AppAdminTokensRoute,
  AppAdminVolumesRoute: AppAdminVolumesRoute,
  AppAdminWebhooksRoute: AppAdminWebhooksRoute,
  AppAdminIndexRoute: AppAdminIndexRoute,
  AppAdminTicketsTicketIdRoute: AppAdminTicketsTicketIdRoute,
  AppAdminUsersUserIdRoute: AppAdminUsersUserIdRoute,
  AppAdminTicketsIndexRoute: AppAdminTicketsIndexRoute,
  AppAdminUsersIndexRoute: AppAdminUsersIndexRoute,
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(
  AppAdminRouteChildren,
)

interface AppOOrgIdBillingRouteChildren {
  AppOOrgIdBillingCreditRoute: typeof AppOOrgIdBillingCreditRoute
  AppOOrgIdBillingInvoicesRoute: typeof AppOOrgIdBillingInvoicesRoute
  AppOOrgIdBillingIndexRoute: typeof AppOOrgIdBillingIndexRoute
}

const AppOOrgIdBillingRouteChildren: AppOOrgIdBillingRouteChildren = {
  AppOOrgIdBillingCreditRoute: AppOOrgIdBillingCreditRoute,
  AppOOrgIdBillingInvoicesRoute: AppOOrgIdBillingInvoicesRoute,
  AppOOrgIdBillingIndexRoute: AppOOrgIdBillingIndexRoute,
}

const AppOOrgIdBillingRouteWithChildren =
  AppOOrgIdBillingRoute._addFileChildren(AppOOrgIdBillingRouteChildren)

interface AppOOrgIdProjectsProjectIdServicesServiceIdRouteChildren {
  AppOOrgIdProjectsProjectIdServicesServiceIdConsoleRoute: typeof AppOOrgIdProjectsProjectIdServicesServiceIdConsoleRoute
  AppOOrgIdProjectsProjectIdServicesServiceIdDeploymentsRoute: typeof AppOOrgIdProjectsProjectIdServicesServiceIdDeploymentsRoute
  AppOOrgIdProjectsProjectIdServicesServiceIdDomainsRoute: typeof AppOOrgIdProjectsProjectIdServicesServiceIdDomainsRoute
  AppOOrgIdProjectsProjectIdServicesServiceIdLogsRoute: typeof AppOOrgIdProjectsProjectIdServicesServiceIdLogsRoute
  AppOOrgIdProjectsProjectIdServicesServiceIdSettingsRoute: typeof AppOOrgIdProjectsProjectIdServicesServiceIdSettingsRoute
  AppOOrgIdProjectsProjectIdServicesServiceIdIndexRoute: typeof AppOOrgIdProjectsProjectIdServicesServiceIdIndexRoute
}

const AppOOrgIdProjectsProjectIdServicesServiceIdRouteChildren: AppOOrgIdProjectsProjectIdServicesServiceIdRouteChildren =
  {
    AppOOrgIdProjectsProjectIdServicesServiceIdConsoleRoute:
      AppOOrgIdProjectsProjectIdServicesServiceIdConsoleRoute,
    AppOOrgIdProjectsProjectIdServicesServiceIdDeploymentsRoute:
      AppOOrgIdProjectsProjectIdServicesServiceIdDeploymentsRoute,
    AppOOrgIdProjectsProjectIdServicesServiceIdDomainsRoute:
      AppOOrgIdProjectsProjectIdServicesServiceIdDomainsRoute,
    AppOOrgIdProjectsProjectIdServicesServiceIdLogsRoute:
      AppOOrgIdProjectsProjectIdServicesServiceIdLogsRoute,
    AppOOrgIdProjectsProjectIdServicesServiceIdSettingsRoute:
      AppOOrgIdProjectsProjectIdServicesServiceIdSettingsRoute,
    AppOOrgIdProjectsProjectIdServicesServiceIdIndexRoute:
      AppOOrgIdProjectsProjectIdServicesServiceIdIndexRoute,
  }

const AppOOrgIdProjectsProjectIdServicesServiceIdRouteWithChildren =
  AppOOrgIdProjectsProjectIdServicesServiceIdRoute._addFileChildren(
    AppOOrgIdProjectsProjectIdServicesServiceIdRouteChildren,
  )

interface AppOOrgIdRouteChildren {
  AppOOrgIdAuditRoute: typeof AppOOrgIdAuditRoute
  AppOOrgIdBillingRoute: typeof AppOOrgIdBillingRouteWithChildren
  AppOOrgIdConnectionsRoute: typeof AppOOrgIdConnectionsRoute
  AppOOrgIdMembersRoute: typeof AppOOrgIdMembersRoute
  AppOOrgIdNotificationsRoute: typeof AppOOrgIdNotificationsRoute
  AppOOrgIdOrderRoute: typeof AppOOrgIdOrderRoute
  AppOOrgIdSettingsRoute: typeof AppOOrgIdSettingsRoute
  AppOOrgIdTokensRoute: typeof AppOOrgIdTokensRoute
  AppOOrgIdIndexRoute: typeof AppOOrgIdIndexRoute
  AppOOrgIdSupportTicketIdRoute: typeof AppOOrgIdSupportTicketIdRoute
  AppOOrgIdProjectsIndexRoute: typeof AppOOrgIdProjectsIndexRoute
  AppOOrgIdSupportIndexRoute: typeof AppOOrgIdSupportIndexRoute
  AppOOrgIdProjectsProjectIdIndexRoute: typeof AppOOrgIdProjectsProjectIdIndexRoute
  AppOOrgIdProjectsProjectIdDatabasesDatabaseIdRoute: typeof AppOOrgIdProjectsProjectIdDatabasesDatabaseIdRoute
  AppOOrgIdProjectsProjectIdServicesServiceIdRoute: typeof AppOOrgIdProjectsProjectIdServicesServiceIdRouteWithChildren
  AppOOrgIdProjectsProjectIdDatabasesIndexRoute: typeof AppOOrgIdProjectsProjectIdDatabasesIndexRoute
}

const AppOOrgIdRouteChildren: AppOOrgIdRouteChildren = {
  AppOOrgIdAuditRoute: AppOOrgIdAuditRoute,
  AppOOrgIdBillingRoute: AppOOrgIdBillingRouteWithChildren,
  AppOOrgIdConnectionsRoute: AppOOrgIdConnectionsRoute,
  AppOOrgIdMembersRoute: AppOOrgIdMembersRoute,
  AppOOrgIdNotificationsRoute: AppOOrgIdNotificationsRoute,
  AppOOrgIdOrderRoute: AppOOrgIdOrderRoute,
  AppOOrgIdSettingsRoute: AppOOrgIdSettingsRoute,
  AppOOrgIdTokensRoute: AppOOrgIdTokensRoute,
  AppOOrgIdIndexRoute: AppOOrgIdIndexRoute,
  AppOOrgIdSupportTicketIdRoute: AppOOrgIdSupportTicketIdRoute,
  AppOOrgIdProjectsIndexRoute: AppOOrgIdProjectsIndexRoute,
  AppOOrgIdSupportIndexRoute: AppOOrgIdSupportIndexRoute,
  AppOOrgIdProjectsProjectIdIndexRoute: AppOOrgIdProjectsProjectIdIndexRoute,
  AppOOrgIdProjectsProjectIdDatabasesDatabaseIdRoute:
    AppOOrgIdProjectsProjectIdDatabasesDatabaseIdRoute,
  AppOOrgIdProjectsProjectIdServicesServiceIdRoute:
    AppOOrgIdProjectsProjectIdServicesServiceIdRouteWithChildren,
  AppOOrgIdProjectsProjectIdDatabasesIndexRoute:
    AppOOrgIdProjectsProjectIdDatabasesIndexRoute,
}

const AppOOrgIdRouteWithChildren = AppOOrgIdRoute._addFileChildren(
  AppOOrgIdRouteChildren,
)

interface AppRouteChildren {
  AppAccountRoute: typeof AppAccountRouteWithChildren
  AppAdminRoute: typeof AppAdminRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppConnectionsGithubRoute: typeof AppConnectionsGithubRoute
  AppOOrgIdRoute: typeof AppOOrgIdRouteWithChildren
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountRoute: AppAccountRouteWithChildren,
  AppAdminRoute: AppAdminRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppConnectionsGithubRoute: AppConnectionsGithubRoute,
  AppOOrgIdRoute: AppOOrgIdRouteWithChildren,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface PublicRouteChildren {
  PublicCloseAccountRoute: typeof PublicCloseAccountRoute
  PublicForgotPasswordRoute: typeof PublicForgotPasswordRoute
  PublicInvitationRoute: typeof PublicInvitationRoute
  PublicRegisterRoute: typeof PublicRegisterRoute
  PublicResetPasswordRoute: typeof PublicResetPasswordRoute
  PublicSignInRoute: typeof PublicSignInRoute
  PublicTwoFactorRoute: typeof PublicTwoFactorRoute
  PublicVerifyEmailRoute: typeof PublicVerifyEmailRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicCloseAccountRoute: PublicCloseAccountRoute,
  PublicForgotPasswordRoute: PublicForgotPasswordRoute,
  PublicInvitationRoute: PublicInvitationRoute,
  PublicRegisterRoute: PublicRegisterRoute,
  PublicResetPasswordRoute: PublicResetPasswordRoute,
  PublicSignInRoute: PublicSignInRoute,
  PublicTwoFactorRoute: PublicTwoFactorRoute,
  PublicVerifyEmailRoute: PublicVerifyEmailRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
